<template>
  <div class="modal fade" id="updateShopProductModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog">
      <form @submit.prevent="UpdateProductStockData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('product.edit_product') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column mb-8 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span >{{$t('product.name')}}</span>
              </label>
              <input type="text" readonly class="form-control form-control-solid" v-model="formProductEditData.name" required  />
            </div>
            <!-- prix HT et TTC côte à côte, les taxes qui passent de l'un à l'autre en dessous -->
            <div class="row mb-3">
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('product.sell_price_ht')}}</span>
                </label>
                <input type="number" step="any" min="0" class="form-control form-control-solid" v-model="formProductEditData.price" required  />
              </div>
              <div class="col-sm-6">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('product.sell_price_ttc')}}</span>
                </label>
                <input type="number" readonly class="form-control form-control-solid" :value="prixTTC(index)" />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12 col-sm-12" >
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span >{{$t('shop.taxe_applied')}}</span>
                </label>
                <select id="kt_select2" data-dropdown-parent="#updateShopProductModal" class="form-select form-select-solid kt_select2" data-control="select2" name="product_shop_taxes[]" v-model="formProductEditData.product_shop_taxes" data-allow-clear="true" multiple="multiple">
                  <option></option>
                  <option  v-for="taxe in getTaxes" :key="taxe.id" :value="taxe.id">{{ taxe.title }} </option>
                </select>
              </div>
            </div>
            <div class="row mt-2" v-if="$hasModule('pos.stock')">
              <div class="col-md-6 col-sm-12">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('product.stock_security')}}</span>
                </label>
                <input type="number" class="form-control form-control-solid" v-model="formProductEditData.stock_security" required  />
              </div>
              <div class="col-md-6 col-sm-12">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('product.stock_alert')}}</span>
                </label>
                <input type="number" class="form-control form-control-solid" v-model="formProductEditData.stock_alert" required  />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_create_update_stock" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "UpdateShopProduct",
    data() {
    return {
      formProductEditData: {
        id: null,
        name: '',
        price : 0,
        stock_security : 0,
        stock_alert : 0,
        product_shop_taxes: []
      }
    }
    },
  props: {
    getTaxes: {
      type: Array,required:false, default:[]
    },
    form: {
      type: Object,required:true
    }
  },
  watch: {
    form: function (value){
      this.formProductEditData = {...value}
    }
  },
  async mounted(){
    this.formProductEditData = this.form
    $("#kt_select2").select2()
    $("#kt_select2").select2().select2()
     $("#kt_select2").change((e) => {
       switch (e.target.name) {
         case 'product_shop_taxes[]':
           this.formProductEditData.product_shop_taxes = []
           let product_shop_taxes = [];
           for (var k = 0, kLen = e.target.selectedOptions.length; k<kLen; k++) {
             if(e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined){
               product_shop_taxes.push(e.target.selectedOptions[k].value);
             }
           }
           this.formProductEditData.product_shop_taxes = product_shop_taxes
           break;
         default:
           break;
       }
     });
   },
  methods: {
    ...mapActions('shop',[
        'updateProductInShop'
    ]),
    
    prixTTC() {
      const produit = this.formProductEditData;
      const taxesProduit = this.getTaxes ? this.getTaxes.filter(taxe => produit.product_shop_taxes.includes(taxe.id)) : [];
      let prixHT = parseFloat(produit.price);
      this.formProductEditData.price = prixHT;
      taxesProduit.forEach(taxe => {
        if (taxe.type === 'percent') {
          prixHT *= 1 + parseFloat(taxe.amount) / 100;
        } else if (taxe.type === 'amount') {
          prixHT += parseFloat(taxe.amount);
        }
      });
      return Math.round(prixHT * 100) / 100;
    },
    async UpdateProductStockData(){
      this.$loading('kt_submit_create_update_stock')
      let data = {
        product_sale_element_id:  this.formProductEditData.id,
        price:  this.formProductEditData.price,
        stock_security:  this.formProductEditData.stock_security,
        stock_alert:  this.formProductEditData.stock_alert,
        product_shop_taxes:  this.formProductEditData.product_shop_taxes,
        name:  this.formProductEditData.name,
        id: this.$route.params.id
      }
      let response = {}
      try{
        response = await this.updateProductInShop(data)
        this.$emit('success')
        window.toastr['success'](i18n.global.t("notification.shop_edit_product"))
        $('#updateShopProductModal').modal('toggle')
        this.$stopLoading('kt_submit_create_update_stock')
        return true
      } catch(err){
        this.$stopLoading('kt_submit_create_update_stock')

      }
    },
  }
}
</script>

<style scoped>

</style>